export default __webpack_public_path__ + "static/media/hht1_direction_quiztime_01.fceea1ae.png";